var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm.groups),function(group,index){return _c('div',{key:index},[_c('v-skeleton-loader',{staticClass:"mb-6 ml-2",attrs:{"type":"heading","width":"500px"}}),_c('BookingListSkeleton',{attrs:{"rows":_vm.rows}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }